<app-breadcrumb [master]="'Należności'" [parentName]="'Generowanie'" [name]="'Generowanie'"></app-breadcrumb>
<div class="receivables-job-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px" [formGroup]="actionForm"  *ngIf="(userPermissions | async).receivables.write">
    <div fxLayoutGap="15px">

      <app-dict-insurance-companies
        [multiple]="false" label="TU" class="receivables-job-list-filter"
        [formControl]="insuranceCompanyControl"
      ></app-dict-insurance-companies>

      <mat-form-field class="receivables-job-list-filter-long" >
        <mat-label>Plik importu</mat-label>
        <mat-select [formControl]="importControl">
          <ng-container *ngFor="let importItem of (importListSubject | async)?.items">
            <mat-option [value]="importItem.uuid" multiLineOption>
              <h4 mat-line>
                {{importItem.name}} <ng-container *ngIf="importItem.importer">({{importItem.importer.name}})</ng-container>
              </h4>
              <p mat-line>
                {{importItem.createdBy?.firstName}} {{importItem.createdBy?.lastName}}, {{importItem.createdAt | date:'y-MM-dd'}}
              </p>
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

<!--      <app-dict-ofwcas class="receivables-job-list-filter"  [multiple]="false" label="OFWCA" [control]="ofwcaControl" [contractMandate]="false" ></app-dict-ofwcas>-->
<!--      <app-dict-partners class="receivables-job-list-filter"  [multiple]="false" label="Partner" [control]="partnerControl" ></app-dict-partners>-->

    </div>
    <div fxLayout="row">
      <button
        (click)="make()" mat-raised-button
        [disabled]="!actionForm.valid"
        color="primary"><mat-icon>play_arrow</mat-icon> <span> Uruchom</span></button>
    </div>
  </div>

  <mat-divider></mat-divider>

  <h3>Historia akcji</h3>

  <div fxLayout="column">
    <table mat-table [dataSource]="jobs" >

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.requestedAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.calledBy">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.calledBy.uuid]">{{element.calledBy.firstName}} {{element.calledBy.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.calledBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="parameters">
        <th mat-header-cell *matHeaderCellDef> Parametry </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.receivablesImport">
            {{element.receivablesImport.name}}, {{element.receivablesImport?.totalRows}} wierszy, {{element.receivablesImport?.createdAt | date:'y-MM-dd'}}
          </ng-container>
          <ng-container *ngIf="element.ofwca">
            <br>OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
          </ng-container>
          <ng-container *ngIf="element.ofwca && element.partner"><br></ng-container>
          <ng-container *ngIf="element.partner">
            <br>Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef> Wynik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.result?.length > 0">
            <ng-container *ngFor="let item of element.result">
              <span>{{item.key}}: {{item.value}}</span><br>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
